import React, { useEffect, useState } from 'react';

import ProgressCircle from 'app/developer-v3/components/ProgressCircle';
import { Colors } from '@zapier/design-system';

type Props = {
  initValue: number;
  height?: number;
};

function AnimatedProgressCircle(props: Props) {
  const { initValue, height } = props;
  const [value, setValue] = useState<number>(0);

  useEffect(() => {
    const roundedValue =
      initValue >= 100
        ? 100
        : initValue >= 95
        ? 95
        : initValue <= 0
        ? 0
        : initValue <= 5
        ? 5
        : Math.round(initValue / 10) * 10;

    // Animation
    const timer = setTimeout(() => setValue(roundedValue), 10);
    return () => clearTimeout(timer);
  }, [initValue]);

  return (
    <ProgressCircle
      barColor={Colors.StatusSuccessStrongest}
      height={height}
      percent={value}
    />
  );
}

export default AnimatedProgressCircle;
